// Mock data for AS COM IT Company Website

export const translations = {
  pl: {
    nav: {
      home: 'Strona główna',
      services: 'Usługi',
      about: 'O nas',
      portfolio: 'Portfolio',
      contact: 'Kontakt'
    },
    hero: {
      title: 'AS COM',
      subtitle: 'Tworzenie stron internetowych i administracja IT',
      description: 'Profesjonalne rozwiązania technologiczne dla Twojego biznesu',
      cta: 'Skontaktuj się'
    },
    services: {
      title: 'Nasze usługi',
      items: [
        {
          id: '1',
          title: 'Tworzenie stron internetowych',
          description: 'Projektujemy i rozwijamy nowoczesne, responsywne strony internetowe dostosowane do Twoich potrzeb biznesowych.',
          icon: 'Globe'
        },
        {
          id: '2',
          title: 'Administracja IT',
          description: 'Kompleksowe zarządzanie infrastrukturą IT, wsparcie techniczne i utrzymanie systemów.',
          icon: 'Server'
        },
        {
          id: '3',
          title: 'Konsultacje techniczne',
          description: 'Doradztwo w zakresie architektury systemów i najlepszych praktyk technologicznych.',
          icon: 'Code'
        }
      ]
    },
    about: {
      title: 'O nas',
      description: 'AS COM to zespół doświadczonych specjalistów IT z siedzibą w Polsce. Specjalizujemy się w tworzeniu nowoczesnych rozwiązań webowych i kompleksowej administracji IT dla firm każdej wielkości.',
      stats: [
        { label: 'Lat doświadczenia', value: '15' },
        { label: 'Zrealizowanych projektów', value: '200' },
        { label: 'Zadowolonych klientów', value: '120' }
      ],
      subtitle: 'Opinie klientów',
      ratings:[
      {
        id: 1,
        name: "Anna Kowalska",
        company: "FutureWeb Solutions",
        rating: 5,
        review: "Niezwykle profesjonalne podejście i szybka realizacja projektu. Jestem pod wrażeniem jakości i dbałości o szczegóły. Serdecznie polecam!"
      },
      {
        id: 2,
        name: "Piotr Nowak",
        company: "GastroMaster",
        rating: 4,
        review: "Świetna współpraca. Drobne opóźnienie, ale finalny produkt przewyższył nasze oczekiwania. Ocena 4/5 za minimalną zwłokę."
      },
      {
        id: 3,
        name: "TechInnovate Sp. z o.o.",
        rating: 5,
        review: "Kompleksowe doradztwo i rewolucyjne rozwiązania. Współpraca na najwyższym poziomie. Nasza firma zyskała nowego, solidnego partnera."
      },
      {
        id: 4,
        name: "Katarzyna Wójcik",
        company: "Creative Studio",
        rating: 5,
        review: "Perfekcyjne wykonanie! Estetyka i funkcjonalność idealnie dopasowane do naszych potrzeb. Zdecydowanie najlepszy wybór."
      },
      ]
    },
    portfolio: {
      title: 'Portfolio',
      items: [
        {
          id: '1',
          title: 'E-commerce Platform',
          description: 'Kompleksowa platforma e-commerce z zaawansowanym systemem zarządzania.',
          category: 'Web Development',
          image: null
        },
        {
          id: '2',
          title: 'Corporate Website',
          description: 'Profesjonalna strona korporacyjna z systemem CMS.',
          category: 'Web Development',
          image: null
        },
        {
          id: '3',
          title: 'IT Infrastructure',
          description: 'Wdrożenie i zarządzanie infrastrukturą IT dla średniego przedsiębiorstwa.',
          category: 'IT Administration',
          image: null
        }
      ]
    },
    contact: {
      title: 'Kontakt',
      subtitle: 'Skontaktuj się z nami',
      form: {
        name: 'Imię i nazwisko',
        email: 'Email',
        message: 'Wiadomość',
        submit: 'Wyślij wiadomość',
        success: 'Wiadomość wysłana pomyślnie!',
        error: 'Wystąpił błąd. Spróbuj ponownie.'
      }
    },
    footer: {
      rights: '© 2025 AS COM. Wszelkie prawa zastrzeżone.',
      location: 'Polska'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      portfolio: 'Portfolio',
      contact: 'Contact'
    },
    hero: {
      title: 'AS COM',
      subtitle: 'Website Development & IT Administration',
      description: 'Professional technology solutions for your business',
      cta: 'Get in touch'
    },
    services: {
      title: 'Our Services',
      items: [
        {
          id: '1',
          title: 'Website Development',
          description: 'We design and develop modern, responsive websites tailored to your business needs.',
          icon: 'Globe'
        },
        {
          id: '2',
          title: 'IT Administration',
          description: 'Comprehensive IT infrastructure management, technical support, and system maintenance.',
          icon: 'Server'
        },
        {
          id: '3',
          title: 'Technical Consulting',
          description: 'Expert advice on system architecture and technology best practices.',
          icon: 'Code'
        }
      ]
    },
    about: {
      title: 'About Us',
      description: 'AS COM is a team of experienced IT specialists based in Poland. We specialize in creating modern web solutions and comprehensive IT administration for businesses of all sizes.',
      stats: [
        { label: 'Years of experience', value: '10+' },
        { label: 'Completed projects', value: '150+' },
        { label: 'Satisfied clients', value: '100+' }
      ],
      subtitle: 'Customer Reviews',
      ratings:[
      {
        id: 1,
        name: "Anna Kowalska",
        company: "FutureWeb Solutions",
        rating: 5,
        review: "Extremely professional approach and quick project delivery. I am impressed with the quality and attention to detail. Highly recommended!"
      },
      {
        id: 2,
        name: "Piotr Nowak",
        company: "GastroMaster",
        rating: 4,
        review: "Excellent cooperation. Minor delay, but the final product exceeded our expectations. 4/5 for minimal delay."
      },
      {
        id: 3,
        name: "TechInnovate Sp. z o.o.",
        rating: 5,
        review: "Comprehensive consulting and revolutionary solutions. Cooperation at the highest level. Our company gained a new, solid partner."
      },
      {
        id: 4,
        name: "Katarzyna Wójcik",
        company: "Creative Studio",
        rating: 5,
        review: "Perfect execution! Aesthetics and functionality perfectly matched to our needs. Clearly the best choice."
      },
      ]
    },
    portfolio: {
      title: 'Portfolio',
      items: [
        {
          id: '1',
          title: 'E-commerce Platform',
          description: 'Comprehensive e-commerce platform with advanced management system.',
          category: 'Web Development',
          image: null
        },
        {
          id: '2',
          title: 'Corporate Website',
          description: 'Professional corporate website with CMS system.',
          category: 'Web Development',
          image: null
        },
        {
          id: '3',
          title: 'IT Infrastructure',
          description: 'Implementation and management of IT infrastructure for mid-sized enterprise.',
          category: 'IT Administration',
          image: null
        }
      ]
    },
    contact: {
      title: 'Contact',
      subtitle: 'Get in touch with us',
      form: {
        name: 'Full name',
        email: 'Email',
        message: 'Message',
        submit: 'Send message',
        success: 'Message sent successfully!',
        error: 'An error occurred. Please try again.'
      }
    },
    footer: {
      rights: '© 2025 AS COM. All rights reserved.',
      location: 'Poland'
    }
  }
};

// Mock function to save contact form (frontend only)
export const saveContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock: Contact form saved to localStorage', formData);
      const existingContacts = JSON.parse(localStorage.getItem('contacts') || '[]');
      existingContacts.push({ ...formData, id: Date.now(), timestamp: new Date().toISOString() });
      localStorage.setItem('contacts', JSON.stringify(existingContacts));
      resolve({ success: true, message: 'Contact saved successfully' });
    }, 500);
  });
};